import { feedbackActionTypes as actionTypes } from '../ActionTypes/feedbackActionTypes';
import type { FeedbackBoard, FeedbackSuggestion, UpvoteResult } from '../Components/Feedback/Feedback.types';

export interface FeedbackReducerState {
    suggestions: FeedbackSuggestion[];
    mySuggestions: FeedbackSuggestion[];
    remainingUpvotes: number | null;
    maxUpvotes: number | null;
    maxSuggestionLength: number | null;
    pendingUpvotes: number[];
}

type FeedbackAction =
    | { type: typeof actionTypes.STORE_FEEDBACK_LIST; data: FeedbackBoard | null | undefined }
    | { type: typeof actionTypes.STORE_MY_FEEDBACK; data: FeedbackSuggestion[] | null | undefined }
    | { type: typeof actionTypes.UPVOTE_STARTED; suggestionId: number }
    | { type: typeof actionTypes.STORE_UPVOTE_RESULT; data: UpvoteResult }
    | { type: typeof actionTypes.UPVOTE_FAILED; suggestionId: number };

const initialState: FeedbackReducerState = {
    suggestions: [],
    mySuggestions: [],
    remainingUpvotes: null,
    maxUpvotes: null,
    maxSuggestionLength: null,
    pendingUpvotes: [],
};

export default function FeedbackReducer(state: FeedbackReducerState = initialState, action: FeedbackAction): FeedbackReducerState {
    switch (action.type) {
        case actionTypes.STORE_FEEDBACK_LIST:
            return {
                ...state,
                suggestions: action.data?.suggestions ?? [],
                remainingUpvotes: action.data?.remainingUpvotes ?? null,
                maxUpvotes: action.data?.maxUpvotes ?? null,
                maxSuggestionLength: action.data?.maxSuggestionLength ?? null,
            };
        case actionTypes.STORE_MY_FEEDBACK:
            return { ...state, mySuggestions: action.data ?? [] };
        case actionTypes.UPVOTE_STARTED:
            return { ...state, pendingUpvotes: [...state.pendingUpvotes, action.suggestionId] };
        case actionTypes.STORE_UPVOTE_RESULT: {
            const result = action.data;
            return {
                ...state,
                suggestions: state.suggestions.map((s) => (s.id === result.suggestionId ? { ...s, upvoteCount: result.upvoteCount, hasUpvoted: result.hasUpvoted } : s)),
                remainingUpvotes: result.remainingUpvotes,
                maxUpvotes: result.maxUpvotes,
                pendingUpvotes: state.pendingUpvotes.filter((id) => id !== result.suggestionId),
            };
        }
        case actionTypes.UPVOTE_FAILED:
            return {
                ...state,
                pendingUpvotes: state.pendingUpvotes.filter((id) => id !== action.suggestionId),
            };
        default:
            return state;
    }
}
